import {
  ServiceState as State,
  ServiceActions as Actions
} from "./service.types";
import {
  RESET_SERVICE,
  SET_CATEGORIES_SELECTED,
  SET_CATEGORIES_SUBCATEGORIES,
  SET_NOTE_IS_PUBLIC,
  SET_REQUESTER,
  SET_TICKET_ENTITY_DATA
} from "./service.actions";

const initialState: State = {
  categories: undefined,
  categoriesSelected: [],
  noteIsPublic: true,
  requester: undefined,
  ticketEntityData: undefined
};

const reducer = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SET_CATEGORIES_SUBCATEGORIES:
      return { ...state, categories: action.payload };
    case SET_CATEGORIES_SELECTED:
      return { ...state, categoriesSelected: action.payload };
    case SET_NOTE_IS_PUBLIC:
      return { ...state, noteIsPublic: action.payload };
    case SET_REQUESTER:
      return { ...state, requester: action.payload };
    case SET_TICKET_ENTITY_DATA:
      return { ...state, ticketEntityData: action.payload };
    case RESET_SERVICE:
      return { ...state };
    default:
      return state;
  }
};

export default reducer;
